define('SC.ThreadsThemeExtension.Common.UtilitiesHelper', [], function () {
    'use strict';
    return {
      toggleViewportToMobileSupport: function toggleViewportToMobileSupport() {
        var viewport = document.head.querySelector("meta[name='viewport']");
        var mobileSupport = "width=device-width, initial-scale=1.0";
        viewport.content = mobileSupport;
      },
      // This was added because isPhoneDevice property is not exposed yet, 
      // This helper was added because the following enhacement: https://jira.corp.netsuite.com/browse/SCTHEMES-415
      // Snippet extracted from: https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent
      isMobile: function isMobile() {
        var hasTouchScreen = false;
        if ("maxTouchPoints" in navigator) {
          hasTouchScreen = navigator.maxTouchPoints > 0;
        } else if ("msMaxTouchPoints" in navigator) {
          hasTouchScreen = navigator.msMaxTouchPoints > 0;
        } else {
          var mQ = window.matchMedia && matchMedia("(pointer:coarse)");
          if (mQ && mQ.media === "(pointer:coarse)") {
            hasTouchScreen = !!mQ.matches;
          } else if ('orientation' in window) {
            hasTouchScreen = true; // deprecated, but good fallback
          } else {
            // Only as a last resort, fall back to user agent sniffing
            var UA = navigator.userAgent;
            hasTouchScreen = (
              /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
              /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA)
            );
          }
        }
        return hasTouchScreen;
      }
    };
  });
